import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { hinhThucChiTietApi } from "../../../api/mien-giam/hinhThucChiTietApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IHinhThucChiTiet } from "../../../model/respone/mien-giam/IHinhThucChiTiet";
import {
  eHinhThucChiTietActionIds,
  IHinhThucChiTietActionTypes,
} from "../../action-types/mien-giam/IHinhThucChiTietActions";
import { NotifyHelper } from "../../../helpers/toast";
import { rootActions } from "../../actions/rootActions";

export function* hinhThucChiTietSaga(): any {
  yield takeLatest(eHinhThucChiTietActionIds.LOAD_START, loadWorker);
  yield takeEvery(eHinhThucChiTietActionIds.SAVE_START, saveWorker);
  yield takeEvery(eHinhThucChiTietActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IHinhThucChiTietActionTypes): any {
  const res: IBaseRespone = yield call(
    hinhThucChiTietApi.SelectAll,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.mienGiam.hinhThucChiTiet.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mienGiam.hinhThucChiTiet.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IHinhThucChiTietActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IHinhThucChiTiet;
  if (payload.id > 0) {
    res = yield call(hinhThucChiTietApi.Update, payload);
  } else {
    res = yield call(hinhThucChiTietApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.mienGiam.hinhThucChiTiet.SAVE_SUCCESS(res.data));
    } else {
      // Không báo ra thì người dùng chỉ thấy "bấm Cập nhật mà không có gì xảy ra".
      NotifyHelper.Error(res.message ?? "Có lỗi");
      yield put(
        rootActions.mienGiam.hinhThucChiTiet.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  } else {
    NotifyHelper.Error("Không nhận được phản hồi từ máy chủ");
    yield put(rootActions.mienGiam.hinhThucChiTiet.SAVE_ERROR("Có lỗi"));
  }
}

function* deleteWorker(action: IHinhThucChiTietActionTypes): any {
  const res: IBaseRespone = yield call(
    hinhThucChiTietApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.mienGiam.hinhThucChiTiet.DELETE_SUCCESS(res.data));
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi");
    yield put(
      rootActions.mienGiam.hinhThucChiTiet.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
